import React, { memo } from "react";
import "./sidebar-panel.css";

/**
 * Can add styling (conditional padding, background) a scrollbar, ... \
 * in the same way for all sidebar panels
 */
export const SidebarPanel = memo(function Sidebar({
	children,
	className,
	style,
}: {
	children: React.ReactNode;
	className?: string;
	style?: React.CSSProperties;
}) {
	return (
		<div className={`sidebar-panel ${className || ""}`} style={style}>
			{children}
		</div>
	);
});
